module.exports = __webpack_public_path__ + "fcdd37a2.svg";